export default __webpack_public_path__ + "vision-safety-alerts-drawing-thumbnail-480-c565fd0169f2435b89063e31e25afb1f.webp";